import { Eye } from 'lucide-react';

import type { SupervisionMessage, SupervisionWatcher } from './types';

/**
 * Faixa discreta acima do Resumo Vivo. Só existe quando há supervisão a mostrar:
 * alguém acompanhando agora, ou histórico de orientações nesta conversa. No dia a dia
 * comum, não renderiza nada — decisão do TL (04/Set/2026): «não é usual; nada de aba».
 */
export function supervisionStripLabel(
  watchers: readonly SupervisionWatcher[],
  messages: readonly SupervisionMessage[],
): string | null {
  if (watchers.length > 0) {
    const first = watchers[0]!.supervisorName;
    const extra = watchers.length > 1 ? ` +${watchers.length - 1}` : '';
    return `Supervisão acompanhando · ${first}${extra}`;
  }
  if (messages.length > 0) {
    return `Supervisão · ${messages.length} ${messages.length === 1 ? 'orientação' : 'orientações'}`;
  }
  return null;
}

export function SupervisionStrip({
  watchers,
  messages,
  unread,
  onOpen,
}: {
  watchers: readonly SupervisionWatcher[];
  messages: readonly SupervisionMessage[];
  unread: number;
  onOpen: () => void;
}): JSX.Element | null {
  const label = supervisionStripLabel(watchers, messages);
  if (label === null) return null;
  const alert = unread > 0;
  return (
    <button
      type="button"
      className={alert ? 'supervision-strip supervision-strip--alert' : 'supervision-strip'}
      onClick={onOpen}
      aria-label={`${label} — abrir orientações da supervisão`}
      data-testid="supervision-strip"
    >
      <span className="supervision-strip__icon" aria-hidden>
        <Eye size={13} />
      </span>
      <span className="supervision-strip__text">{label}</span>
      {alert && (
        <span className="supervision-strip__count" data-testid="supervision-unread">
          {unread} {unread === 1 ? 'nova' : 'novas'}
        </span>
      )}
    </button>
  );
}
